import KollectiveXHR from '../../interceptor/KollectiveXHR';
import { BitmovinHttpRequest } from '@kollective-frontend/ksdk-api';

// See: https://bitmovin.com/docs/player/api-reference/web/web-sdk-api-reference-v8#/player/web/8/docs/interfaces/core_network.networkconfig.html#sendhttprequest
const send = async (
  request: BitmovinHttpRequest,
  kollectiveXhr: KollectiveXHR
): Promise<void> => {
  kollectiveXhr.responseType = request.responseType;
  kollectiveXhr.open(request.method, request.url, true);
  kollectiveXhr.send(request.body);
};

const toHeaders = (req: XMLHttpRequest): Record<string, string> => {
  const arr = req.getAllResponseHeaders().split('\r\n');
  return arr.reduce((acc: Record<string, string>, val: string) => {
    const array = val.split(':', 2);
    if (array.length == 2) {
      acc[array[0]] = array[1].trim(); // NOT SUPPORTED IE8
    }
    return acc;
  }, {} as Record<string, string>);
};

export { send, toHeaders };
